import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface SetPreferredPharmacyParams {
  pharmacyId: string;
}

interface SetPreferredPharmacyResponse {
  bundle: object;
}

export const useSetPreferredPharmacy = ({
  patientId,
}: { patientId: string }) => {
  const queryClient = useQueryClient();

  return useApiMutation<
    SetPreferredPharmacyResponse,
    SetPreferredPharmacyParams
  >({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.PreferredPharmacy.SET_PHARMACY(patientId),
      mutationFn: (params) => {
        return axiosInstance.put(
          `/rx/patients/${patientId}/preferred-pharmacy`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.PreferredPharmacy.DEFAULT(patientId),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.DEFAULT(patientId),
        });
      },
    },
  });
};
